import { CarouselComponent } from 'src/scripts/components/carousel'
import { BaseComponent } from '../../components/base-component'
import { $el, $list, $elParent } from 'src/scripts/utils/utils'

const { Shopify } = window

const POSTER_SELECTOR = '[id^="Deferred-Poster-"]'

export class ProductModel extends BaseComponent {
  modelViewerUI: any

  mountComponent() {
    const poster = $el(POSTER_SELECTOR, this)

    this.addListener(poster, 'click', this.handlePosterClick)
    this.carousel?.embla.on('select', this.handleCarouselSelect)
  }

  unmountComponent() {
    this.carousel?.embla.off('select', this.handleCarouselSelect)
  }

  handlePosterClick = () => {
    this.loadContent()
  }

  handleCarouselSelect = () => {
    if (this.carousel) {
      this.setCarouselDraggable(true)
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      this.addModel()
      this.setAttribute('loaded', 'true')

      if (this.carousel) {
        this.setCarouselDraggable(false)
      }
    }

    Shopify.loadFeatures(
      [
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ],
      () => {},
    )
  }

  addModel() {
    const template: HTMLTemplateElement = $el('template', this)

    if (!template || !template.content) {
      return
    }

    const templateContent = template.content
    const content = document.createElement('div')

    content.appendChild(templateContent.firstElementChild.cloneNode(true))
    const modelViewer = $el('model-viewer', content)

    this.appendChild(modelViewer)
  }

  setupModelViewerUI(errors) {
    if (errors) {
      return
    }

    this.modelViewerUI = new Shopify.ModelViewerUI($el('model-viewer', this))
  }

  setCarouselDraggable(isDraggable) {
    const modelViewer = $el('.shopify-model-viewer-ui', this)

    this.carousel.dataset.draggable = isDraggable ? 'true' : 'false'
    this.carousel.reInit()

    if (isDraggable && modelViewer) {
      modelViewer.remove()

      this.removeAttribute('loaded')
    }
  }

  get carousel(): CarouselComponent {
    return $elParent('carousel-component', this)
  }
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures(
      [
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ],
      () => {},
    )
  },

  setupShopifyXR(errors) {
    if (errors) {
      return
    }

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR(),
      )
      return
    }

    $list('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
      modelJSON.remove()
    })
    window.ShopifyXR.setupXRElements()
  },
}

window.addEventListener('DOMContentLoaded', () => {
  if (Shopify.designMode) {
    $list('[data-shopify-xr-hidden]').forEach(element =>
      element.classList.add('hidden'),
    )
  }

  if (window.ProductModel) {
    window.ProductModel.loadShopifyXR()
  }
})
